import React, { FunctionComponent, ReactNode } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { SxProps, Theme } from "@mui/system";



export type EnhancedPageTitleProps = {
  title: string;
  icon?: ReactNode;
  button1Text?: string;
  button1Action?: () => void;
  button2Text?: string;
  button2Action?: () => void;
  sx?: SxProps<Theme>;
};

export const EnhancedPageTitle: FunctionComponent<EnhancedPageTitleProps> = ({
  title,
  icon,
  button1Text,
  button1Action,
  button2Text,
  button2Action,
  sx = {},
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      mb={3}
      borderRadius={2}
      boxShadow="0px 0px 42px -18px rgba(0,0,0,0.1);"
      bgcolor="#ffffff"
      sx={sx}
    >
      <Box display="flex" alignItems="center" gap={2}>
        {icon && <Box>{icon}</Box>}
        <Typography variant="h6" fontWeight={600} sx={{color:"#4d4f52"}}>
          {title}
        </Typography>
      </Box>

      <Stack direction="row" spacing={2}>
        {button1Text && (
          <Button variant="contained" color="primary" onClick={button1Action} sx={{background:"#2e5bd9"}}>
            {button1Text}
          </Button>
        )}
        {button2Text && (
          <Button variant="outlined" color="primary" onClick={button2Action} sx={{color:"#2e5bd9"}}>
            {button2Text}
          </Button>
        )}
      </Stack>
    </Box>
  );
};